import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import "./styles.css";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App parcelShowcase={import.meta.env.VITE_DEFAULT_DEMO === "parcel" || new URLSearchParams(window.location.search).get("demo") === "parcel"} />
  </React.StrictMode>
);
